import {
  Modal,
  LoadingIcon,
} from '@panwds/react-ui'

import type { VFC } from 'react'
import type { RenderModalProps } from '@panwds/react-ui'

const LoadingModal: VFC<RenderModalProps> = (props) => {
  const { isOpen } = props

  return (
    <Modal
      size='md'
      isOpen={isOpen}
      addClassName='cm-h-28 cm-w-28 cm-justify-center cm-items-center'
    >
      <LoadingIcon size='4xl'/>
    </Modal>
  )
}

export default LoadingModal
